import React, { createContext, useContext, useEffect } from 'react';

import { useDataProvider } from 'react-admin';
import { isInArray } from 'utils/general';

export const globalFilterKeys = ["terminal_id"];
export const globalUserDataKey = "global-filters";

const filterFilterKeys = (data) => (
    Object.fromEntries(
        Object.entries(data ?? {})
            .filter(([key, _]) => isInArray(globalFilterKeys, key))
    )
);

const GridUserDataGlobalFiltersContext = createContext();

const GridUserDataGlobalFiltersProvider = ({ children }) => {
	const dataProvider = useDataProvider();

    const [data, setData] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        refreshData();
    }, []);

    const refreshData = () => {
        setIsLoading(true);
        dataProvider
            .getOne(
                "user-data",
                {
                    id: globalUserDataKey
                }
            ).then(({ data }) => {
                setData(filterFilterKeys(data?.data));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const updateData = (filterData) => {
        dataProvider
            .update(
                "user-data", 
                { 
                    id: globalUserDataKey, 
                    data: { 
                        data: filterFilterKeys({
                            ...data, 
                            ...filterData
                        }),
                    },
                },
            ).then(({ data }) => {
                setData(filterFilterKeys(data?.data));
            });
    };

    const contextValue = {
        data,
        isLoading,
        refreshData,
        updateData,
    };

    return (
        <GridUserDataGlobalFiltersContext.Provider value={contextValue}>
            {children}
        </GridUserDataGlobalFiltersContext.Provider>
    );
};

const useGridUserDataGlobalFiltersContext = () => {
    const context = useContext(GridUserDataGlobalFiltersContext);
  
    if (!context) {
        throw new Error('GridUserDataGlobalFiltersContext must be used within an GridUserDataGlobalFiltersProvider');
    }
  
    return context;
};


export { GridUserDataGlobalFiltersProvider, useGridUserDataGlobalFiltersContext };